<template>
    <div v-if="$page.props.auth.user.sale_banner_mtd_url" @click="goToSale"
        class="sales-banner my-3 position-relative d-flex justify-content-center cursor-pointer">
        <img alt="Product on Sale" :src="$page.props.auth.user.sale_banner_mtd_url" />
    </div>
</template>

<script>
export default {
    props: {
    },
    methods: {
        goToSale() {
            if (this.$page.props.auth.user.sale_id) {
                this.$inertia.visit(this.route('mtd.wholesale.sale', this.$page.props.auth.user.sale_id))
            }
        }
    }
}
</script>

<style scoped>
.sales-banner img {
    max-height: 150px;
    max-width: 100%;
    width: auto;
    object-fit: cover;
    object-position: top;
}
</style>
